import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AuthProvider } from "./contexts/AuthContext";
import Routes from "./Routes";
import "./lib/i18n";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set initial direction based on current language
    const dir = i18n?.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n?.language;

    // Add Arabic font link if Arabic is selected
    if (i18n?.language === 'ar') {
      const link = document.createElement('link');
      link.href = 'https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700&family=Tajawal:wght@400;500;700&display=swap';
      link.rel = 'stylesheet';
      document.head?.appendChild(link);
    }
  }, [i18n?.language]);

  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
}

export default App;
